import { z } from "zod"
import { debouncedValidatePhoneNumber } from "@/lib/validate-phone-number"
import { phoneNumberValidation } from "@/modules/patients/components/phoneNumber/PhoneNumberInput"
import { Language, MedicalPrescription } from "@/types/__generated__/union-types"

export const NeuropsychologicDiagnosticPrescriptionBaseSchema = z.object({
  language: z.custom<Language>(),
  healthcareProviderId: z.string().optional(),
  name: z.string().max(50, { message: "common.fieldErrorList.characterLimit" }),
  phoneNumber: z.string(),
  email: z
    .email({ message: "common.fieldErrorList.invalidEmail" })
    .max(254, { message: "common.fieldErrorList.characterLimit" })
    .optional()
    .or(z.literal("")),
  relationship: z.string().max(200, { message: "common.fieldErrorList.characterLimit" }),
  medicalPrescriptions: z.array(z.custom<MedicalPrescription>()).min(1, {
    message: "common.fieldErrorList.requiredField",
  }),
})

export const NeuropsychologicDiagnosticPrescriptionSchema = NeuropsychologicDiagnosticPrescriptionBaseSchema.extend({
  phoneNumber: phoneNumberValidation(debouncedValidatePhoneNumber()),
})

export type NeuropsychologicDiagnosticPrescription = z.infer<typeof NeuropsychologicDiagnosticPrescriptionSchema>
